module.exports = __webpack_public_path__ + "static/media/Team 29 Fusion Cuisine 1210748763 - Haopeng Lu.8b7b7b1b.jpg";